import Cookies from 'js-cookie';

export default (): string => {
    const lang: string | undefined = Cookies.get('lang');
    switch (lang) {
        case undefined:
            return 'en';
        default:
            return lang;
    }
};
